var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { RedirectErrorDialog } from './redirect-error/redirect-error.dialog';
import { BuildOptionsService } from './build-options.service';
import { TokenService } from './tokens.service';
import { STORAGE_KEY } from '../common/constants';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./build-options.service";
import * as i3 from "@angular/router";
import * as i4 from "@angular/material/dialog";
import * as i5 from "./tokens.service";
var RestService = /** @class */ (function () {
    function RestService(http, buildOptionsService, router, dialog, tokenService, opts) {
        this.http = http;
        this.buildOptionsService = buildOptionsService;
        this.router = router;
        this.dialog = dialog;
        this.tokenService = tokenService;
        this.opts = opts;
        this.deviceToken = localStorage.getItem(STORAGE_KEY.AUTH_DEVICE_TOKEN) || null;
    }
    RestService.prototype.generateLogs = function (type, url, dataSent, dataReturned) {
        console.log("%c " + type.toUpperCase() + " API CALL TO", 'background-color: #333; color: #98bccd;');
        console.log(url);
        console.log("%c DATA SENT", 'background-color: #333; color: #fac5c5;');
        console.table(dataSent);
        console.log("%c DATA RETURNED", 'background-color: #333; color: #f5f5f5;');
        console.table(dataReturned);
    };
    RestService.prototype.generateHttpPromise = function (httpMethod, url, body) {
        var _this = this;
        if (body === void 0) { body = null; }
        var promise = null;
        if (body) {
            promise = this.http[httpMethod](url, body, {
                headers: this.buildOptionsService.buildOptions()
            })
                .toPromise()
                .catch(function (err) { return _this.handleError(err); });
        }
        else {
            promise = this.http[httpMethod](url, {
                headers: this.buildOptionsService.buildOptions()
            })
                .toPromise()
                .catch(function (err) { return _this.handleError(err); });
        }
        if (!environment.production && this.opts && this.opts.logXhr) {
            promise.then(function (res) {
                _this.generateLogs(httpMethod, url, body, res);
            });
        }
        promise.then(function (res) {
            if (res && res.data && res.data.redirectUrl) {
                _this.router.navigate([res.data.redirectUrl]);
                if (!_this.redirectErrorDialogRef) {
                    _this.redirectErrorDialogRef = _this.dialog.open(RedirectErrorDialog, {
                        data: res.data
                    });
                    _this.redirectErrorDialogRef
                        .afterClosed()
                        .toPromise()
                        .then(function () {
                        _this.redirectErrorDialogRef = null;
                    });
                }
            }
        });
        return promise;
    };
    RestService.prototype.post = function (url, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenService.checkTokens()];
                    case 1:
                        _a.sent();
                        if (this.tokenService.isTokenExpired) {
                            this.router.navigate(['/login']);
                            this.tokenService.isTokenExpired = false;
                            return [2 /*return*/, Promise.resolve()];
                        }
                        return [2 /*return*/, this.generateHttpPromise('post', url, body)];
                }
            });
        });
    };
    RestService.prototype.get = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenService.checkTokens()];
                    case 1:
                        _a.sent();
                        if (this.tokenService.isTokenExpired) {
                            this.router.navigate(['/login']);
                            this.tokenService.isTokenExpired = false;
                            return [2 /*return*/, Promise.resolve()];
                        }
                        return [2 /*return*/, this.generateHttpPromise('get', url)];
                }
            });
        });
    };
    RestService.prototype.resolve = function (url) {
        return this.http.get(url, {
            headers: this.buildOptionsService.buildOptions()
        });
    };
    RestService.prototype.delete = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenService.checkTokens()];
                    case 1:
                        _a.sent();
                        if (this.tokenService.isTokenExpired) {
                            this.router.navigate(['/login']);
                            this.tokenService.isTokenExpired = false;
                            return [2 /*return*/, Promise.resolve()];
                        }
                        return [2 /*return*/, this.generateHttpPromise('delete', url)];
                }
            });
        });
    };
    RestService.prototype.put = function (url, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenService.checkTokens()];
                    case 1:
                        _a.sent();
                        if (this.tokenService.isTokenExpired) {
                            this.router.navigate(['/login']);
                            this.tokenService.isTokenExpired = false;
                            return [2 /*return*/, Promise.resolve()];
                        }
                        return [2 /*return*/, this.generateHttpPromise('put', url, body)];
                }
            });
        });
    };
    RestService.prototype.handleError = function (serverError) {
        try {
            console.log('Caught try', serverError);
        }
        catch (e) {
            console.log('Caught catch', e);
        }
    };
    RestService.ngInjectableDef = i0.defineInjectable({ factory: function RestService_Factory() { return new RestService(i0.inject(i1.HttpClient), i0.inject(i2.BuildOptionsService), i0.inject(i3.Router), i0.inject(i4.MatDialog), i0.inject(i5.TokenService), i0.inject("RestServiceOpts", 8)); }, token: RestService, providedIn: "root" });
    return RestService;
}());
export { RestService };
